import styles from './ccf-inbox-cards.module.scss';
import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Badge, Box, Collapse, Divider } from '@mui/material';
import { useDispatch, useSelector, batch } from 'react-redux';
import {
  rejectACDCall,
  setSelectedContact,
  activeContactSelector,
  selectInboxCollapsedState,
  loadContactHistoryData,
  rejectDigitalContact,
  updateAppSpaceTab,
  setIsDocked,
  getContactOutBoundCallStatus,
  setNewCommitment,
  updateAppSpaceTabIndex,
  setIsHungUp,
  setIsRejected,
  setIsCallAccepted,
  getIsCallAccepted,
  updateActiveContact,
} from '../ccf-inbox.slice';
import {
  CcfMissingIdVoiceIcon,
  CcfInstaIcon,
  CcfPhoneInboundIcon,
  CcfPhoneRingingIcon,
  CcfButton,
  CcfAuthenticatedVoiceIcon,
  CcfListeningVoiceIcon,
  CcfNotAuthenticatedVoiceIcon,
  CcfCallRejectedIcon,
  CcfTypography,
  CcfCard,
  useTranslator,
  CcfFacebookIcon,
  CcfWritingIcon,
  CcfLinkedinIcon,
  CcfDialogBox,
  CcfChatIcon,
  CcfInteractionCompleteIcon,
  CcfTooltip,
  CcfEmailIcon,
  CcfVoiceMailIcon,
  CcfBadNumberIcon,
  CcfFaxIcon,
  CcfBox,
  CcfSnackBar,
  CcfAlert,
  CcfPhoneOutboundIcon,
  CcfOutboundwithPhoneIcon,
  CcfInboundIcon,
  CcfOutboundIcon,
  CcfXIcon,
  CcfSmsIcon,
  CcfOutboundElevationIcon,
} from '@nice-ccf/ui-controls';
import { useHistory } from 'react-router';
import {
  MediaType,
  VoiceContactStatus,
  DigitalChannelType,
  VoiceAuthenticationStatus,
  DigitalChannelStatus,
} from '@nice-ccf/core-sdk';
import { Contact } from '../../ccf-inbox/model/contact';
import {
  agentStateActions,
  selectcurrentStatus,
  selectIsWorkingOB,
} from '../../ccf-agent-state/ccf-agent-state.slice';
import {
  getSelectedMenuName,
  globalActions,
} from '../../../lib/global.app.slice';
import { Navigation } from '../../../enums/navigation-menus';
import {
  CcfContactControlPanel,
  CcfReschedulePopover,
  ccfrtigActions,
  CcfVoicemailControlPanel,
  updateCopilotCardListForEmail,
  updateCopilotCardListForVideoCall,
  updateCopilotCardListForVoice,
  updateLoadAutoSummary,
  updateSpaceBtnCounterForCopilotCard,
  updateSpaceBtnCounterForCopilotEmail,
  updateSpaceBtnCounterForCopilotVoice,
} from '@nice-ccf/ui-components';
import { formatTimer } from '../../../util/common';
import { AppSpace } from '../../../enums/app-space-tabs';
import { getccfrtigState } from '../../ccf-rtig/+state/ccf-rtig.slice';
import { copilotCard } from '../../ccf-app-space/ccf-copilot/mock-data/copilot-mock-data';
import { useMsal } from '@azure/msal-react';
import { North } from '@mui/icons-material';

const rtigInitialState = {
  overallSentiment: {
    guid: 'f090fad6-f869-4a87-a137-455160de6968',
    tag: 'Sentiment',
    image_src: 'meh',
    is_sentiment_score: true,
    percentage: -1,
  },

  suggestionsList: [],

  guidanceScoreList: [
    {
      guid: '6ca702e9-2996-4b55-b572-741a39286f13',
      tag: 'ThankForLoyality',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Thank For Loyalty',
      image_src: 'thank-for-loyalty',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Thank the client for being loyal',
    },

    {
      guid: '7e30c59a-f91f-4326-96d1-276dd7644f9c',
      tag: 'BeEmpathetic',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Be Empathetic',
      image_src: 'be-empathetic',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Understand the issue first',
    },
    {
      guid: '867e5e2b-b85f-486b-b715-cea7234ffb3c',
      tag: 'ActiveListening',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Active Listening',
      image_src: 'active-listening',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Understand the issue first',
    },
    {
      guid: 'd32ef5e0-708c-40a4-bd4b-f391d36ecd1b',
      tag: 'EmpowerClient',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Mpower Client',
      image_src: 'empower-client',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Share helpful resources',
    },

    {
      guid: '142b1843-fd24-4718-a074-067984dbad63',
      tag: 'SpeechVelocity',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Speech Velocity',
      image_src: 'speech-velocity',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: "Speak more slowly, don't rush",
    },
    {
      guid: '49588d44-ce6b-4129-a20c-dbd4ad752688',
      tag: 'AskQuestions',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Ask Questions',
      image_src: 'ask-questions',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Be curious and ask questions',
    },
    {
      guid: 'fa1f40a1-e7d7-4788-ad16-4b125571bacb',
      tag: 'SetExpectations',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Set Expectations',
      image_src: 'set-expectations',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Explain the full process',
    },
    {
      guid: '59563b8c-35cf-4d90-8620-15cd0c5e6dc1',
      tag: 'NoInterruptons',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'No Interruptions',
      image_src: 'no-interruptions',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Wait for them to finish talking',
    },
    {
      guid: '8e6542e7-09e3-4350-89a0-d4d2cd733fa8',
      tag: 'DemonstrateOwnership',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Take Ownership',
      image_src: 'demonstrate-ownership',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Own the solution end to end',
    },
    {
      guid: '70daadef-5d0a-4ee4-987e-900616ecef25',
      tag: 'BuildRapport',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Build Rapport',
      image_src: 'build-rapport',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Be friendly, ask about their day!',
    },
    {
      guid: '39e68dd2-8785-4bec-8586-c1d85f707ffe',
      tag: 'IdentifySolution',
      type: 'SENTIMENT_MODEL',
      frienly_name: 'Identify Solution',
      image_src: 'identify-solution',
      is_sentiment_score: false,
      percentage: 50,
      isValid: true,
      alertDescription: 'Solved the issue successfully',
    },
  ],

  isSuggestionSummaryExpanded: true,
  isGuidanceScoreExpanded: true,
  resourceBaseUrl: '.',
  showAgentAssist: false,
};

/* eslint-disable-next-line */
export interface CcfInboxCardsProps {
  contact: Contact;
  callType: 'p2p' | 'conference';
}
const IconsLeftMap = new Map([
  ['Inbound', <CcfInboundIcon />],
  ['Outbound', <CcfOutboundIcon />],
]);
const RightIconMap = new Map([
  [
    VoiceContactStatus.RINGING.toString(),
    <CcfPhoneRingingIcon className="rightImage" />,
  ],
  [
    MediaType.VOICEMAIL.toString(),
    <CcfVoiceMailIcon
      style={{ width: '30px', height: '15px', fill: '#767676' }}
      className="phoneOutbound"
    />,
  ],
  [
    VoiceContactStatus.ACTIVE.toString(),
    <CcfListeningVoiceIcon className="rightImage" />,
  ],
  [
    VoiceAuthenticationStatus.AUTHENTICATED.toString(),
    <CcfAuthenticatedVoiceIcon className="rightImage" />,
  ],
  [
    VoiceAuthenticationStatus.NOTAUTHENTICATED.toString(),
    <CcfNotAuthenticatedVoiceIcon className="rightImage" />,
  ],
  [
    VoiceAuthenticationStatus.MISSINGPATRONID.toString(),
    <CcfMissingIdVoiceIcon className="rightImage" />,
  ],
  [
    DigitalChannelType.INSTAGRAM.toString(),
    <Badge
      overlap="circular"
      classes={{ badge: styles.notificationBadge }}
      variant="dot"
    >
      <CcfInstaIcon className="digitalRightImage" />
    </Badge>,
  ],
  [
    DigitalChannelType.TWITTER.toString(),
    <Badge
      overlap="circular"
      classes={{ badge: styles.notificationBadge }}
      variant="dot"
    >
      <CcfXIcon className="digitalRightImage" />
    </Badge>,
  ],
  [
    DigitalChannelType.FACEBOOK.toString(),
    <Badge
      overlap="circular"
      classes={{ badge: styles.notificationBadge }}
      variant="dot"
    >
      <CcfFacebookIcon viewBox="-2 2 24 24" className="digitalRightImage" />
    </Badge>,
  ],
  [
    DigitalChannelType.LINKEDIN.toString(),
    <Badge
      overlap="circular"
      classes={{ badge: styles.notificationBadge }}
      variant="dot"
    >
      <CcfLinkedinIcon className="digitalRightImage" />
    </Badge>,
  ],
  [DigitalChannelType.CHAT, <CcfChatIcon className="rightImage" />],
  [DigitalChannelType.EMAIL, <CcfEmailIcon className="rightImage" />],
  [DigitalChannelStatus.OPEN, <CcfWritingIcon className="rightImage" />],
  ['elevation', <CcfOutboundElevationIcon />],
]);

export const CcfInboxCards = React.forwardRef(
  (props: CcfInboxCardsProps) => {
    const dispatch = useDispatch();
    const { id, media } = props.contact;
    const selectedContact = useSelector(activeContactSelector);
    const isInboxCollpased = useSelector(selectInboxCollapsedState);
    const selectedMenuName = useSelector(getSelectedMenuName);
    const [callCounter, setCallCounter] = useState(0);
    const [acceptRejectCounter, setAcceptCount] = useState(30);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [showRejected, setshowRejected] = useState(false);
    const [isRTAStatus, setIsRTAStatus] = useState(false);
    const [showButtons, setShowButton] = useState(true);
    const [animationForHungUp, setanimationForHungUp] = useState(false);
    const timerIdRef = useRef(0);
    const [translate, locale] = useTranslator();
    const { setCurrentStatus } = agentStateActions;
    const { setSelectedMenu } = globalActions;
    const { resetRtigScore } = ccfrtigActions;
    //const { setInteractionHeaderTabs, setInteractionForActiveContact, completeInteractionForContact } = interactionSliceActions;
    const ContactOutboundCallStatus = useSelector(getContactOutBoundCallStatus);
    const isWorkingOB = useSelector(selectIsWorkingOB);
    const isCallAccepted = useSelector(getIsCallAccepted);
    const [messageType, setMessageType] = useState(props.contact.messageType);
    const [isContactUpdated, setIsContactUpdated] = useState(false);
    const [isCallRejected, setIsCallRejected] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [showReschedulePopover, setShowReschedulePopover] = useState(false);
    const agentState = useSelector(selectcurrentStatus);
    const timerCountToShowAgentAssist = 10;

    const setAssignAgentObj = {
      agentId: '6343848',
      agentName: 'Aman Raj',
      agentStatus: agentState,
      agentTeam: 'Avengers',
      agentDepartment: 'Customer Service',
    };

    useEffect(() => {
      if (isCallAccepted) {
        setMessageType('Dialing...');
        setTimeout(() => {
          setMessageType(props.contact.messageType);
        }, 3000);
      }
    }, [isCallAccepted]);

    // useEffect(() => {
    //   if (!selectedContact?.isElevated) {
    //     dispatch(updateAppSpaceTab({ tab: AppSpace.CUSTOMERCARD }));
    //     dispatch(updateAppSpaceTabIndex({ index: 0 }));
    //   }
    // }, [selectedContact?.id]);

    /**
     * Function wrapped in accept contact function to handle state updates
     * @example handleStateUpdates();
     */
    const handleStateUpdates = useCallback(() => {
      // Batch synchronous state updates
      batch(() => {
        setShowButton(false);
        setIsRTAStatus(false);

        if (selectedMenuName !== Navigation.INTERACTION) {
          dispatch(setSelectedMenu({ name: Navigation.INTERACTION }));
        }

        if (!isWorkingOB) {
          dispatch(setCurrentStatus('working'));
        }
      });
    }, [selectedMenuName, isWorkingOB]);

    /**
     * Function wrapped in accept contact function to Handle timer with cleanup
     * @example setupTimer();
     */
    const setupTimer = useCallback(() => {
      clearInterval(timerIdRef.current);
      const timerId : any = setInterval(() => {
          setCallCounter((prevCount) => {
              if (prevCount === timerCountToShowAgentAssist) {
                  dispatch(ccfrtigActions.setShowAgentAssist(true));
              }
              return prevCount + 1;
          });
      }, 1000);
      timerIdRef.current = timerId;
  }, [dispatch, timerCountToShowAgentAssist]);
  
  // Clear the interval when the component unmounts
  useEffect(() => {
      return () => clearInterval(timerIdRef.current);
  }, []);
  
    /**
     * Function wrapped in accept contact function to Handle contact updates
     * @example handleScreenPop();
     */
    const updateContact = useCallback(() => {
      const updates = {
        contactStatus:
          media === MediaType.VOICE
            ? VoiceContactStatus.ACTIVE
            : DigitalChannelStatus.OPEN,
        ...(media === MediaType.VOICE ? { rtigState: rtigInitialState } : {}),
      };

      // Batch contact updates
      if (media === MediaType.VOICE) {
        dispatch(
          updateActiveContact({
            id: id || '',
            updates: updates,
          })
        );

        if (isWorkingOB) {
          batch(() => {
            dispatch(setIsHungUp(false));
            dispatch(setIsRejected(false));
            dispatch(setIsCallAccepted(true));
          });
        }
      } else {
        dispatch(
          updateActiveContact({
            id: id || '',
            updates: updates,
          })
        );
      }
    }, [props.contact?.media, props.contact?.id, isWorkingOB]);

    /**
     * Function wrapped in accept contact function to open url in popup window
     * @example handleScreenPop();
     */
    const handleScreenPop = () => {
      const { screenPopPreference, screenPopURL } = props.contact;

      if (screenPopURL) {
        switch (screenPopPreference) {
          case 'New Tab':
            window.open(screenPopURL);
            break;
          case 'External Window':
            window.open(screenPopURL, 'HELP CENTER', 'height=800,width=1000');
            break;
        }
      }
    };

    // Add error handler for ResizeObserver
    useEffect(() => {
      /**
       * Function to handle resize observer error on page rerender and on page load
       * @example handleResizeError();
       */
      const handleResizeError = (error: any) => {
        if (error.message.includes('ResizeObserver')) {
          error.stopPropagation();
        }
      };

      window.addEventListener('error', handleResizeError);
      return () => window.removeEventListener('error', handleResizeError);
    }, []);

    useEffect(() => {
      if (!props.contact.isOutboundCall) {
        timerIdRef.current = parseInt(
          setInterval(() => setAcceptCount((c) => c - 1), 1000).toString()
        );
        if (acceptRejectCounter === 0) {
          clearInterval(timerIdRef.current);
          rejectContact({});
        }
      } else {
        acceptContact();
      }
      return () => {
        clearInterval(timerIdRef.current);
      };
    }, [acceptRejectCounter]);

    useEffect(() => {
      if (
        props.contact.contactStatus === DigitalChannelStatus.RESOLVED ||
        (props.contact.contactStatus === VoiceContactStatus.DISCONNECTED &&
          props?.contact.autoSummary === 'Off') ||
        (props.contact.contactStatus === VoiceContactStatus.RESOLVED &&
          props?.contact.autoSummary !== 'Off')
      ) {
        triggerHungUp();
      } else if (props.contact.contactStatus === VoiceContactStatus.ACTIVE) {
        setTimeout(() => dispatchContactRTAState(), 10000);
      }
    }, [props.contact.contactStatus]);

    /**
     * Function executed when accept button is clicked of contact card
     * @example acceptContact();
     */
    const acceptContact = () => {
      requestAnimationFrame(() => {
        handleStateUpdates();
        setupTimer();
        updateContact();
        handleScreenPop();

        dispatch(
          updateActiveContact({
            id: id || '',
            updates: { assignedAgent: setAssignAgentObj },
          })
        );

        dispatch(setSelectedContact(props.contact));
      });
    };
    /**
     * Function is executed when user clicks on an assignment box card
     * @example updateSelectedContact()
     */
    const updateSelectedContact = () => {
      if (props.contact?.media === MediaType.VOICE) {
        dispatch(
          updateActiveContact({
            id: selectedContact ? selectedContact?.id : props.contact.id || '',
            updates: {
              rtigState: rtigInitialState,
              agentAssist: rtigInitialState
            },
          })
        );
      }
      if (selectedMenuName !== Navigation.INTERACTION) {
        dispatch(setSelectedMenu({ name: Navigation.INTERACTION }));
      }
      if (!selectedContact?.isDocked) {
        dispatch(
          setIsDocked({
            id: selectedContact ? selectedContact.id : '',
            isDocked: true,
          })
        );
      }
      dispatch(setSelectedContact(props.contact));
      dispatch(
        loadContactHistoryData({
          activeContact: props.contact,
          start: 0,
          next: 2,
          filterByCategory: 'all',
        })
      );
      // dispatch(resetRtigScore());
    };

    /**
     * Function is executed when reject button is clicked of assignment box card
     * @example rejectContact();
     */
    const rejectContact = (e: any) => {
      // dispatch(setIsHungUpOrRejected(true));
      setShowButton(false);
      setshowRejected(true);
      setTimeout(() => {
        dispatch(setIsRejected(true));
        if (props.contact.media === MediaType.VOICE)
          dispatch(rejectACDCall(props.contact.id));
        else dispatch(rejectDigitalContact(props.contact.id));
      }, 1000);
      dispatch(setIsHungUp(false));
      dispatch(setIsRejected(false));
      if (isWorkingOB) {
        setIsCallRejected(true);
      }
      if (e?.target !== undefined) {
        e.stopPropagation();
      }
    };

    /**
     * Function to dipatch RTA status for contact
     * @example dispatchContactRTAState()
     */
    const dispatchContactRTAState = () => {
      dispatch(
        updateActiveContact({
          id: props.contact.id || '',
          updates: { rtaStatus: props.contact.rtaStatus },
        })
      );
      setIsRTAStatus(true);
      updateRTAStatusIcon();
    };

    /**
     *  Function to update RTA status Icon for contact
     * @example updateRTAStatusIcon()
     * @returns updated RTA status Icon
     */
    const updateRTAStatusIcon = () => {
      return (
        <div className="callStatusWrapper">
          <div className="callStatusIcon">
            {isRTAStatus &&
            props.contact.rtaStatus &&
            !(props.contact.isElevated && props.contact.interaction)
              ? RightIconMap.get(props.contact.rtaStatus)
              : props.contact.contactStatus &&
                !(props.contact.isElevated && props.contact.interaction)
              ? RightIconMap.get(props.contact.contactStatus)
              : RightIconMap.get('elevation')}
          </div>
        </div>
      );
    };

    /**
     * Function to handle dialog close
     * @param e - React.SyntheticEvent
     * @example handleDialogClose(e)
     */
    const handleDialogClose = () => {
      setIsDialogOpen(false);
    };

    /**
     * Function is executed when hungup button is clicked
     * @example triggerHungUp()
     */
    const triggerHungUp = () => {
      // dispatch(setSelectedContact(props.contact));

      setshowRejected(true);
      dispatch(resetRtigScore());
      setTimeout(() => {
        setanimationForHungUp(true);
      }, 200);
      setTimeout(() => {
        if (props.contact.media === MediaType.VOICE)
          dispatch(rejectACDCall(props.contact.id));
        else {
          dispatch(rejectDigitalContact(props.contact.id));
        }
      }, 2200);
      dispatch(setNewCommitment(false));
      dispatch(setIsHungUp(true));
      dispatch(setIsCallAccepted(false));
      if (props.contact?.media === MediaType.VIDEOCALL) {
        dispatch(updateSpaceBtnCounterForCopilotCard(0));
        dispatch(updateLoadAutoSummary(false));
        dispatch(
          updateCopilotCardListForVideoCall({
            data: [],
            type: 'reset',
          })
        );
      }
      if (props.contact?.media === MediaType.VOICE) {
        dispatch(updateSpaceBtnCounterForCopilotVoice(0));
        dispatch(
          updateCopilotCardListForVoice({
            data: [],
            type: 'reset',
          })
        );
      }
      if (props.contact?.channel === DigitalChannelType.EMAIL) {
        dispatch(updateSpaceBtnCounterForCopilotEmail(0));
        dispatch(
          updateCopilotCardListForEmail({
            data: [],
            type: 'reset',
          })
        );
      }

      // dispatch(completeInteractionForContact({interactionID : props.contact.id}));
    };

    // /**
    //  * Function is executed when copilot summary submit button is clicked
    //  * @example triggerCopilotHungUp()
    //  */
    // const triggerCopilotHungUp = () => {
    //   if (
    //     isCopilotSummarySubmitted &&
    //     props.contact.channel === 'CopilotChat' &&
    //     selectedContact
    //   ) {
    //     setshowRejected(true);
    //     dispatch(resetRtigScore());
    //     setTimeout(() => {
    //       setanimationForHungUp(true);
    //     }, 200);
    //     setTimeout(() => {
    //       dispatch(rejectDigitalContact(selectedContact.id));
    //     }, 2200);
    //     dispatch(setNewCommitment(false));
    //     dispatch(setIsHungUp(true));
    //     dispatch(setIsCallAccepted(false));
    //   }
    // };

    /**
     * Function is executed when hungup button is clicked
     * @example triggerHungUp()
     */
    function inboxCardClickHandler() {
      //history.push('/dashboard/Assignment');      
        updateSelectedContact();      
    }

    /**
     * Used to close the snackbar
     * @param event -React.SyntheticEvent
     * @param reason -string
     * @example - handleClose()
     */
    const updateContactHandler = () => {
      setTimeout(() => {
        dispatch(
          updateActiveContact({
            id: props.contact.id || '',
            updates: { contactStatus: VoiceContactStatus.DISCONNECTED },
          })
        );
      }, 1000);
      setIsContactUpdated(true);
    };

    /**
     * Used to close the snackbar
     * @param event -React.SyntheticEvent
     * @param reason -string
     * @example - handleClose()
     */
    const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
      if (reason === 'clickaway') {
        return;
      }
      if (isContactUpdated) {
        setIsContactUpdated(false);
      } else if (isCallRejected) {
        setIsCallRejected(true);
      }
    };

    /**
     * Used to open Reschedule Popover
     * @param event -React.SyntheticEvent
     * @param reason -string
     * @example - openReschedulePopover()
     */
    const openReschedulePopover = (event: any) => {
      acceptContact();
      setAnchorEl(event.currentTarget);
      setShowReschedulePopover(true);
    };

    /**
     * @example reschedulePopovercloseHandler()
     */
    const reschedulePopovercloseHandler = () => {
      setAnchorEl(null);
      setShowReschedulePopover(false);
    };

    return (
      <>
        <Box
          className={styles.card}
          onClick={() => {
            inboxCardClickHandler();
          }}
        >
          {isInboxCollpased ? (
            <CcfCard
              className={`${
                props.contact.active
                  ? 'activeCardCollapsed '
                  : 'inactiveCardCollapsed '
              }`}
            >
              {props.contact.media === MediaType.VOICE ? (
                <>
                  <CcfPhoneInboundIcon className="phoneOutboundCollapsed" />
                  {props.contact.contactStatus !== VoiceContactStatus.RINGING
                    ? updateRTAStatusIcon()
                    : props.contact.contactStatus
                    ? RightIconMap.get(props.contact.contactStatus)
                    : ''}
                </>
              ) : props.contact.media === MediaType.DIGITAL ? (
                props.contact?.channel &&
                !(props.contact.isElevated && props.contact.interaction) ? (
                  RightIconMap.get(props.contact.channel)
                ) : (
                  RightIconMap.get('elevation')
                )
              ) : props.contact.media === MediaType.VOICEMAIL ? (
                RightIconMap.get(props.contact.media)
              ) : (
                RightIconMap.get(props.contact.contactStatus)
              )}
              <CcfTypography
                variant="inherit"
                className={
                  props.contact.id === selectedContact?.id
                    ? 'activeTimer'
                    : 'timer'
                }
              >
                {showButtons
                  ? formatTimer(acceptRejectCounter)
                  : formatTimer(callCounter)}
              </CcfTypography>
            </CcfCard>
          ) : !showRejected ? (
            <CcfCard
              id="ccf-active-call"
              className={`${
                props.contact.id === selectedContact?.id
                  ? 'active '
                  : 'inactive '
              }`}
            >
              <Box className="sectionTop">
                <Box className="cardLeft">
                  <CcfTypography variant="inherit" className="customerName">
                    {[
                      props?.contact?.customer?.firstName,
                      props?.contact?.customer?.middleName,
                      props?.contact?.customer?.lastName,
                    ]
                      .filter(Boolean)
                      .join(' ')}
                  </CcfTypography>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    {(props.contact.media === MediaType.VOICE ||
                      props.contact.media === MediaType.VOICEMAIL ||
                      props.contact.media === MediaType.VIDEOCALL) &&
                    !isWorkingOB &&
                    !selectedContact?.isWorkingOB ? (
                      IconsLeftMap.get('OutBound')
                    ) : props.contact.channel &&
                      !isWorkingOB &&
                      !selectedContact?.isWorkingOB ? (
                      IconsLeftMap.get('Inbound')
                    ) : (
                      <CcfOutboundwithPhoneIcon className="phoneOutbound" />
                    )}
                    <CcfTypography
                      variant="inherit"
                      className={`${
                        props.contact.media === MediaType.VOICE
                          ? 'phoneNumber'
                          : props.contact.media === MediaType.VOICEMAIL
                          ? undefined
                          : 'channelDetail1'
                      }`}
                    >
                      {props.contact.media !== MediaType.VOICEMAIL &&
                      !(props.contact.isElevated && props.contact.interaction)
                        ? messageType
                        : props.contact.isElevated && props.contact.interaction
                        ? props.contact.media !== MediaType.DIGITAL
                          ? `${Object.keys(props.contact.interaction).length} ${
                              Object.keys(props.contact.interaction).length ===
                              1
                                ? 'channel'
                                : 'channels'
                            }`
                          : Object.keys(props.contact.interaction).length > 1
                          ? `${
                              Object.keys(props.contact.interaction).length
                            } channels`
                          : messageType
                        : messageType}
                    </CcfTypography>
                  </Box>
                  {/* {props.contact.queueName.length > 25 ? (
                    <CcfTypography
                      variant="inherit"
                      className="channelDetailEllipsis"
                      title={props.contact.queueName}
                    >
                      {props.contact.queueName}
                    </CcfTypography>
                  ) : (
                    <CcfTypography variant="inherit" className="channelDetail">
                      {ContactOutboundCallStatus
                        ? 'Outbound Callback'
                        : props.contact.queueName}
                    </CcfTypography>
                  )} */}
                  {/* below line should not display when contact populated from simulator */}
                  {(isWorkingOB || selectedContact?.isWorkingOB) && (
                    <CcfTypography
                      variant="inherit"
                      className="channelDetail"
                      style={{ marginTop: '-10px', marginBottom: '5px' }}
                    >
                      Cust. Service Request
                    </CcfTypography>
                  )}
                </Box>
                {/* <Divider
                  orientation="vertical"
                  variant="fullWidth"
                  className="cardDivider"
                />
                <Box className="cardRight">
                  {props.contact.media === MediaType.VOICE
                    ? props.contact.contactStatus !== VoiceContactStatus.RINGING
                      ? updateRTAStatusIcon()
                      : props.contact.contactStatus
                      ? RightIconMap.get(props.contact.contactStatus)
                      : null
                    : props.contact.media === MediaType.DIGITAL
                    ? props.contact.channel &&
                      !(
                        props.contact.isElevated &&
                        props.contact.interaction &&
                        Object.keys(props.contact.interaction).length! > 1
                      )
                      ? RightIconMap.get(props.contact.channel)
                      : RightIconMap.get('elevation')
                    : props.contact.media === MediaType.VOICEMAIL
                    ? RightIconMap.get(props.contact.media)
                    : isRTAStatus
                    ? RightIconMap.get(VoiceAuthenticationStatus.AUTHENTICATED)
                    : RightIconMap.get(props.contact.contactStatus)}
                  <CcfTypography
                    variant="inherit"
                    className={
                      props.contact.id === selectedContact?.id
                        ? 'activeTimer'
                        : 'timer'
                    }
                  >
                  {showButtons
                      ? formatTimer(acceptRejectCounter)
                      : formatTimer(callCounter)}
                  </CcfTypography>
                </Box> */}
              </Box>
              {!props.contact?.isOutboundCall && (
                <Collapse in={showButtons} timeout={500}>
                  <Box className="buttonDiv">
                    <CcfButton
                      variant="contained"
                      id={
                        props.contact?.channel
                          ? `agent_activeContact_rejectButton_${props.contact?.channel}`
                          : `agent_activeContact_rejectButton`
                      }
                      color="inherit"
                      className={'niceDefaultBtn'}
                      disableElevation
                      onClick={(e) => rejectContact(e)}
                    >
                      {translate('reject')}
                    </CcfButton>
                    <CcfButton
                      variant="contained"
                      id={
                        props.contact?.channel
                          ? `agent_activeContact_acceptButton_${props.contact?.channel}`
                          : `agent_activeContact_acceptButton`
                      }
                      color="inherit"
                      className={'nicePrimaryBtn'}
                      disableElevation
                      onClick={acceptContact}
                    >
                      {translate('accept')}
                    </CcfButton>
                  </Box>
                  {(isWorkingOB || selectedContact?.isWorkingOB) && (
                    <CcfBox className="rescheduleLink">
                      <CcfTypography
                        onClick={(e: any) => openReschedulePopover(e)}
                      >
                        Reschedule
                      </CcfTypography>
                    </CcfBox>
                  )}
                </Collapse>
              )}
              {props.contact.media === MediaType.VOICE &&
                props.contact.contactStatus !== VoiceContactStatus.RINGING &&
                props.contact.isDocked === true &&
                props.callType === 'p2p' &&
                (isWorkingOB || selectedContact?.isWorkingOB) &&
                messageType !== 'Dialing...' && (
                  <div className="carControlPanelWorkingOB">
                    <CcfVoiceMailIcon
                      style={{ fill: '#3F5C69', cursor: 'pointer' }}
                      onClick={updateContactHandler}
                    />
                    <CcfBadNumberIcon
                      style={{ cursor: 'pointer' }}
                      onClick={updateContactHandler}
                    />
                    <CcfFaxIcon
                      style={{ cursor: 'pointer' }}
                      onClick={updateContactHandler}
                    />
                  </div>
                )}
              {(props.contact.media === MediaType.VOICE ||
                props.contact.media === MediaType.VIDEOCALL) &&
                props.contact.contactStatus !== VoiceContactStatus.RINGING &&
                props.contact.isDocked === true &&
                props.callType === 'p2p' && (
                  <div className="carControlPanelContainer">
                    <CcfContactControlPanel
                      iconArr={props.contact.contactButtons}
                      showHeader={
                        isWorkingOB || selectedContact?.isWorkingOB
                          ? false
                          : true
                      }
                      showSubHeading={true}
                      headerText={
                        isWorkingOB || selectedContact?.isWorkingOB
                          ? ''
                          : `${[
                              props?.contact?.customer?.firstName,
                              props?.contact?.customer?.middleName,
                              props?.contact?.customer?.lastName,
                            ]
                              .filter(Boolean)
                              .join(' ')}`
                      }
                      subHeading2={
                        isWorkingOB || selectedContact?.isWorkingOB
                          ? '#439-Z3FM-5S23+Cust. Service +'
                          : '#439-Z3FM-5S23+Cust. Service Request'
                      }
                      contact={props.contact}
                      messageTye={messageType}
                    ></CcfContactControlPanel>
                  </div>
                )}
              {props.contact.media === MediaType.VOICEMAIL &&
                props.contact.isDocked === true &&
                props.callType === 'p2p' && (
                  <div className="carControlPanelContainer">
                    <CcfVoicemailControlPanel
                      contact={props.contact}
                      outBoundCallinitiated={ContactOutboundCallStatus || false}
                    ></CcfVoicemailControlPanel>
                  </div>
                )}
              {props.contact.media === MediaType.DIGITAL &&
                props.contact.contactStatus !== DigitalChannelStatus.NEW &&
                props.contact.isDocked === true &&
                props.callType === 'p2p' &&
                props.contact.id === selectedContact?.id && (
                  <div className="carControlPanelContainer">
                    <CcfContactControlPanel
                      iconArr={props.contact.contactButtons}
                      showHeader={true}
                      showSubHeading={
                        props.contact.channel === DigitalChannelType.EMAIL ||
                        props.contact.channel === DigitalChannelType.CHAT ||
                        props.contact.channel ===
                          DigitalChannelType.CHATWITHBOTRANSCRIPT
                          ? true
                          : false
                      }
                      subHeading1={
                        props.contact.channel === DigitalChannelType.EMAIL
                          ? 'Viewing Email'
                          : props.contact.channel === DigitalChannelType.CHAT
                          ? 'Viewing Chat'
                          : props.contact.channel ===
                            DigitalChannelType.CHATWITHBOTRANSCRIPT
                          ? ''
                          : "Viewing 'X' Page"
                      }
                      subHeading2="#439-Z3FM-5S23+Cust. Service"
                      headerText={`${[
                        props?.contact?.customer?.firstName,
                        props?.contact?.customer?.middleName,
                        props?.contact?.customer?.lastName,
                      ]
                        .filter(Boolean)
                        .join(' ')}`}
                      contact={props.contact}
                    ></CcfContactControlPanel>
                  </div>
                )}
              {props.contact.isElevated &&
                props.contact.interaction &&
                (props.contact.media === MediaType.VOICE ||
                  (props.contact.media === MediaType.DIGITAL &&
                    Object.keys(props.contact.interaction).length > 1)) && (
                  <div className={styles.elevatedCard}>
                    <div className={styles.elvationDetails}>
                      <div>
                        <CcfTypography className={styles.elevationId}>
                          {props.contact.id}
                        </CcfTypography>
                      </div>
                      <div style={{ display: 'flex' }}>
                        <North style={{ fontSize: '16px', color: '#767676' }} />
                        <CcfTypography className={styles.elevationTxt}>
                          {props.contact?.activeInteraction
                            ? `${
                                props.contact.interaction[
                                  props.contact.activeInteraction!
                                ]?.skill
                              }`
                            : ''}
                        </CcfTypography>
                      </div>
                    </div>
                    <div className={styles.elevationIcon}>
                      {props.contact?.activeInteraction?.includes('sms') ? (
                        <CcfSmsIcon />
                      ) : props.contact?.activeInteraction?.includes(
                          'email'
                        ) ? (
                        <CcfEmailIcon style={{ color: '#007ab8' }} />
                      ) : props.contact?.activeInteraction?.includes('chat') ? (
                        <CcfChatIcon style={{ marginTop: '10px' }} />
                      ) : null}
                    </div>
                  </div>
                )}
            </CcfCard>
          ) : props.contact.contactStatus === DigitalChannelStatus.NEW ||
            props.contact.contactStatus === VoiceContactStatus.RINGING ? (
            <CcfCard className={'active rejected '}>
              <Box className="rejectAnimation">
                <CcfTypography
                  variant="inherit"
                  className={'rejectText'}
                  translationKey={
                    props.contact.media === MediaType.VOICE
                      ? 'callRejected'
                      : 'digitalInteractionRejected'
                  }
                ></CcfTypography>
                <CcfCallRejectedIcon
                  viewBox="0 0 34 34"
                  className="rejectIcon"
                ></CcfCallRejectedIcon>
              </Box>
            </CcfCard>
          ) : (
            <CcfCard className={`active hungUpAnimation`}>
              <Box
                className={`hangUpContainer + ${
                  animationForHungUp ? 'hungUpClass' : ''
                }`}
              >
                <CcfTypography className={'hungUpText'}>
                  Interaction <br /> completed
                </CcfTypography>
                <CcfInteractionCompleteIcon
                  viewBox="0 0 34 34"
                  className="hungUpIcon"
                ></CcfInteractionCompleteIcon>
              </Box>
            </CcfCard>
          )}
          <div>
            <CcfDialogBox
              isOpen={isDialogOpen}
              handleOnClose={handleDialogClose}
              title={translate('rtaDialogTitle')}
              primaryButtonText={translate('enroll')}
              secondaryButtonText={translate('cancel')}
              secondaryButtonProps={{
                className: 'niceDefaultBtn',
                variant: 'text',
                color: 'primary',
                fullWidth: false,
              }}
              primaryButtonProps={{
                className: 'nicePrimaryBtn',
                variant: 'contained',
                color: 'primary',
                fullWidth: false,
              }}
            >
              <div>Enter Text here</div>
            </CcfDialogBox>
          </div>
          <CcfBox>
            <CcfSnackBar
              onClose={() => handleClose()}
              open={isContactUpdated}
              autoHideDuration={3000}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <div>
                <CcfAlert closeAlert={handleClose} severity="success">
                  Contact updated
                </CcfAlert>
              </div>
            </CcfSnackBar>
          </CcfBox>
          <CcfBox>
            <CcfSnackBar
              onClose={() => handleClose()}
              open={isCallRejected}
              autoHideDuration={3000}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <div>
                <CcfAlert closeAlert={handleClose} severity="success">
                  Call successfully requeued
                </CcfAlert>
              </div>
            </CcfSnackBar>
          </CcfBox>
        </Box>
        {showReschedulePopover && messageType !== 'Dialing...' && (
          <CcfReschedulePopover
            anchorEl={anchorEl}
            reschedulePopovercloseHandler={reschedulePopovercloseHandler}
            triggerHungUp={triggerHungUp}
          />
        )}
      </>
    );
  }
);

export default CcfInboxCards;
